import { createApp } from 'vue';
import App from '../forms/App.vue';

const app = createApp(App);

window.onload = () => {
  window.CHATSUITE_FORM = app.mount('#app');
};
